const actions = {
    REGISTER_GOCAR_SIMPLE: 'REGISTER_GOCAR_SIMPLE',
    REGISTER_STATUS: 'REGISTER_STATUS',

    VALIDATE_REFERRAL_REQUEST: 'VALIDATE_REFERRAL_REQUEST',
    VALIDATE_REFERRAL_SUCCESS: 'VALIDATE_REFERRAL_SUCCESS',
    VALIDATE_REFERRAL_FAILURE: 'VALIDATE_REFERRAL_FAILURE',

    registerGocarSimple: payload => ({
        type: actions.REGISTER_GOCAR_SIMPLE,
        payload
    }),
    registerStatus: payload => ({
        type: actions.REGISTER_STATUS,
        payload
    }),
    validateReferral: payload => ({
        type: actions.VALIDATE_REFERRAL_REQUEST,
        payload
    })
};
export default actions;
  


// WEBPACK FOOTER //
// ./src/redux/register/actions.js